import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { FC } from 'react';

import { useNavigateDialogForm } from '../../../components/formikDialogForm/dialogForm.hook';
import { VisibleIfAdmin } from '../../auth/components/VisibleIfAdmin';

import { MitarbeiterTable } from './MitarbeiterTable';

export const MitarbeiterListScreen: FC = () => {
  const navigateDialog = useNavigateDialogForm('mitarbeiter', 'create');
  return (
    <div>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Mitarbeiter
      </Typography>
      <VisibleIfAdmin>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Add />}
          onClick={() => navigateDialog()}
          sx={{ mb: 3 }}
        >
          Neuer Mitarbeiter
        </Button>
      </VisibleIfAdmin>
      <MitarbeiterTable />
    </div>
  );
};
